(function () {
  'use strict';

  var id = "activity";
  angular.module('wsLrs.cards').controller(id + ".CardConfiguration", ["$scope", function ($scope) {
    $scope.workingConfig.type = id;
    $scope.activityPickerConfig.require.activity = true;
    $scope.updateCardWithWorkingConfig();
  }]);
})();
